const API_URL = process.env.NODE_ENV === "development" ? "http://localhost:8080" : "https://api.prijslijstapp.nl";
export default API_URL;
export const EMPTY_PRICES_CROSSED = false;

export const S3_BUCKET = "staging-pricelist-images-bucket";
export const S3_UPLOAD_BUCKET = "staging-pricelist-images-bucket"; // TODO correct? or: staging-pricelist-downloads-bucket? or: staging-pricelist-tmp-images-bucket?

export const REGION = "eu-central-1";
// next 2 constants are unused
export const AWS_ACCESS_KEY_ID = "AKIA6L2ISDD6WDTMVRYU";
export const AWS_SECRET_ACCESS_KEY = "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";

// Todo: use separate websocket for staging -> for now ok to re-use prod but when we want to
//  change websocket stuff we should use a staging websocket env...
export const WEBSOCKET_URL = "wss://8k632v48gk.execute-api.eu-central-1.amazonaws.com/prod";

export const PUBLIC_URL = "https://shop.prijslijstapp.nl";
